"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getURLParam = void 0;
const getURLParam = (param) => {
    const url = new URL(window.location.href);
    if (url.search) {
        return url.searchParams.get(param);
    }
    const hash = url.hash.split('#state=').pop();
    return new URLSearchParams(decodeURIComponent(hash)).get(param);
};
exports.getURLParam = getURLParam;
